import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import { apiFetch } from '../utils/api';

const LogSessionModal = ({ workout, dayIndex, onClose, onSaved }) => {
  const day = workout.days?.[dayIndex];
  const [exercises, setExercises] = useState(
    day?.exercises?.map((_, i) => ({ exercise_index: i, weight: '', reps: '', notes: '' })) || []
  );
  const [loading, setLoading] = useState(false);

  const updateExercise = (index, field, value) => {
    const updated = [...exercises];
    updated[index][field] = value;
    setExercises(updated);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await apiFetch("/api/sessions", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          workout_id: workout.workout_id,
          day_index: dayIndex,
          exercises
        })
      });

      if (response.ok) {
        onSaved();
      }
    } catch (error) {
      console.error('Error saving session:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay-bottom" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} data-testid="log-session-modal">
        <div className="modal-header">
          <h2 className="modal-title">{day?.name}</h2>
          <button className="btn btn-icon btn-secondary" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {day?.exercises?.map((exercise, index) => (
          <div key={index} className="card mb-4" style={{ background: 'var(--secondary)' }}>
            <p style={{ fontWeight: '600', marginBottom: '8px', color: 'var(--foreground)' }}>
              {exercise.name}
            </p>
            <p className="text-muted mb-2" style={{ fontSize: '12px' }}>
              Objetivo: {exercise.sets}
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                type="text"
                className="input"
                placeholder="Peso (kg)"
                value={exercises[index]?.weight || ''}
                onChange={(e) => updateExercise(index, 'weight', e.target.value)}
                style={{ flex: 1 }}
                data-testid={`log-weight-${index}`}
              />
              <input
                type="text"
                className="input"
                placeholder="Reps (10,10,8)"
                value={exercises[index]?.reps || ''}
                onChange={(e) => updateExercise(index, 'reps', e.target.value)}
                style={{ flex: 1 }}
                data-testid={`log-reps-${index}`}
              />
            </div>
            <input
              type="text"
              className="input mt-2"
              placeholder="Notas"
              value={exercises[index]?.notes || ''}
              onChange={(e) => updateExercise(index, 'notes', e.target.value)}
            />
          </div>
        ))}

        <button
          className="btn btn-primary w-full"
          onClick={handleSubmit}
          disabled={loading}
          data-testid="save-session-btn"
        >
          <Save size={16} />
          {loading ? 'Guardando...' : 'Guardar Sesión'}
        </button>
      </div>
    </div>
  );
};

export default LogSessionModal;
